function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Smartphone_text"
}, /*#__PURE__*/React.createElement("title", null, "VF_smartphone_text_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M99.2 42.5h42.5v14.2H99.2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "120.5",
  cy: "223.2",
  r: "17.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.4 85h-63.8V28.3c0-15.6-12.7-28.3-28.3-28.3H56.7C41.1 0 28.3 12.7 28.3 28.3v226.8c0 15.6 12.7 28.3 28.3 28.3h127.6c15.6 0 28.3-12.7 28.3-28.3v-99.3h63.8V85zm-92.2 42.5c-3.9 0-7.1-2.2-7.1-7.1 0-4.9 3.2-7.1 7.1-7.1s7.1 2.2 7.1 7.1c0 4.9-3.1 7.1-7.1 7.1zm.1 127.6H56.7V28.3h127.6v56.6h-42.5v99.3l28.2-28.5h14.3v99.4zm28.3-127.6c-3.9 0-7.1-2.2-7.1-7.1 0-4.9 3.2-7.1 7.1-7.1s7.1 2.2 7.1 7.1c0 4.9-3.2 7.1-7.1 7.1zm28.3 0c-3.9 0-7.1-2.2-7.1-7.1 0-4.9 3.2-7.1 7.1-7.1s7.1 2.2 7.1 7.1c0 4.9-3.1 7.1-7.1 7.1z"
}))));